import PropTypes from 'prop-types'
import React from 'react'
import TextField from '../../molecules/fields/TextField'
import { useTranslation } from 'react-i18next'
import { Field } from 'react-final-form'
import * as validations from '../../../utils/validations'

const UbigeoField = ({ baseName, question, questionTranslated }) => {
  const { t } = useTranslation('form')

  const renderTextField = (name, hint, initialValue) => (
    <Field name={name}>
      {({ input }) => {
        if (input.value === '' && name !== `${baseName}.payload.label`) {
          input.onChange(initialValue)
        }
        const isDisabled = name !== `${baseName}.payload.label`

        return (
          <TextField
            label="Etiqueta de la pregunta"
            hint={hint}
            {...input}
            margin="none"
            disabled={isDisabled}
            size="full"
            className="mb-4"
            placeholder="Ingresa la traducción"
            validate={validations.required()}
            capsLockInfo
          />
        )
      }}
    </Field>
  )

  return (
    <div className="grid flex-wrap gap-4">
      <div>
        {renderTextField(`${baseName}.payload.label`, question.payload.label, questionTranslated?.payload.label || '')}
        {renderTextField(
          `${baseName}.payload.ubigeo_region_label`,
          'Departamento',
          t('form_label_department') || 'Departamento'
        )}
        {renderTextField(`${baseName}.payload.ubigeo_city_label`, 'Provincia', t('form_label_province') || 'Provincia')}
        {renderTextField(
          `${baseName}.payload.ubigeo_district_label`,
          'Distrito',
          t('form_label_district') || 'Distrito'
        )}
      </div>
    </div>
  )
}

export default UbigeoField

UbigeoField.propTypes = {
  baseName: PropTypes.string,
  question: PropTypes.object,
  questionTranslated: PropTypes.object
}
